<template>
<span>
  <b-tooltip
    label="Share Report Link"
    position="is-bottom"
  >
    <a
      href="#_"
      label=""
      @click="cardReportLink"
    >
      <b-icon
        pack="fas"
        icon="share-alt-square"
      />
    </a>
  </b-tooltip>
</span>
</template>

<script>
  import ReportLinkForm from '@frontend/dash3/js/components/report-links/ReportLinkForm.vue';

  export default {
    data() {
      return {}
    },
    props: {
      reportUrl: String,
      portfolio: Object,
    },
    methods: {
      cardReportLink() {
        this.$buefy.modal.open({
          parent: this,
          component: ReportLinkForm,
          hasModalCard: true,
          customClass: 'custom-class custom-class-2',
          trapFocus: true,
          props: {'reportUrl': this.reportUrl, 'portfolio': this.portfolio}
        });
      }
    }
  }
</script>
